const isArrayCheck = (value) => {
  return Array.isArray(value) ? value : [];
};

export default isArrayCheck;
